import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsPatientYearQueryKey({
  personaName,
  year
}: {
  personaName?: string
  year: number
}) {
  return ['operationalCAAMetricsPatientYear', { personaName, year }]
}

export function useOperationalCAAMetricsPatientYearQuery({
  personaName,
  year,
  enabled
}: {
  personaName?: string
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsPatientYearQueryKey({
      personaName,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsPatientYear({
        personaName,
        year
      }),
    enabled
  })
}
